import { zIndexes } from '../../../const/zIndexes';
import { pxToRem } from '../../../helpers/rem';
export const getDynamicPinningTableStickyStyles = ({ isPinned, isMeasured, stickyLeftPx, pinnedWidthPx, }) => {
    const isStickyPositioned = isPinned && isMeasured;
    const stickyLeftRem = pxToRem(stickyLeftPx ?? 0);
    const pinnedWidthRem = isPinned
        ? pxToRem(pinnedWidthPx ?? 0)
        : undefined;
    return {
        position: isStickyPositioned ? 'sticky' : undefined,
        left: isStickyPositioned ? stickyLeftRem : undefined,
        zIndex: isStickyPositioned ? zIndexes.tableStickyColumn : undefined,
        width: pinnedWidthRem,
        minWidth: pinnedWidthRem,
        maxWidth: pinnedWidthRem,
    };
};
